import { Languages } from '../../enums'

const browserLanguage = (): string => (navigator && (
  navigator.language ||
  navigator['browserLanguage'] ||
  navigator['userLanguage'] ||
  (navigator.languages && navigator.languages[0]) || 'en'
)).toLowerCase().slice(0, 2)

/** Dynamically imports the language copy used for the CMP */
export const handleLocale = async (): Promise<{ copy: object, language: string }> => {
  const language: string = Languages[browserLanguage()] || Languages.en
  //@ts-ignore
  const copy = await import(/* webpackChunkName: "gdprModal" */ `./copy/${language}`)
  return { copy: copy.default , language }
}
